
import { Component, Vue } from "vue-property-decorator";
import { jobCategory } from "@/axios/request/job";
import { KeyValue } from "@/utils/common-data";

@Component
export default class RecruitCategory extends Vue {
  categoryId = window.sessionStorage.getItem("categoryId");
  category: KeyValue[] = [];
  categoryName = "";
  loading = false;
  setCategoryId(item: string, id: string) {
    this.categoryId = id;
    window.sessionStorage.setItem("categoryId", this.categoryId);
    window.sessionStorage.setItem("categoryName", item);
    // 提醒右侧职位列表调用接口获取数据
    this.$bus.$emit("updateCategoryDetail", true);
  }
  async setCategory() {
    try {
      this.loading = true;
      const { data: res } = await jobCategory();
      console.log(res);
      if (res.code === 200) {
        this.category = res.data;
        this.categoryName = res.data[0];
        if (!window.sessionStorage.getItem("categoryName")) {
          window.sessionStorage.setItem("categoryName", "");
        }
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.error(res.msg);
      }
    } catch {
      this.loading = false;
      return this.$message.error("网络错误，请稍后再试");
    }
  }
  mounted() {
    this.setCategory();
    if (this.categoryName) {
      this.$router.go(0);
    }
    this.$bus.$on("editCategoryActive", (data: boolean) => {
      if (data) {
        this.categoryId = "-1";
      }
    });
  }
  beforeDestroy() {
    this.$bus.$off("editCategoryActive");
  }
}
